import VisitorApi from '@/api/visitor'
const uploadApiArr = ['uploadFile', 'uploadImage', 'operateAndUpload']

// apiName为src/api/visitor.ts文件中定义的方法名
export default function uploadFiles(
	fileList: File[],
	maxSize = 10,
	apiName = 'uploadFile'
) {
	return new Promise((resolve, reject) => {
		if (!uploadApiArr.includes(apiName)) {
			console.error(`uploadFiles上传文件方法仅支持${uploadApiArr.join(', ')}`)
			return reject()
		}

		if (!(Array.isArray(fileList) && fileList && fileList.length > 0)) {
			console.error(`uploadFiles fileList不可为空`)
			return reject()
		}

		// 校验文件大小
		for (let file of fileList) {
			if (file.size > maxSize * 1024 * 1024) {
				return reject({
					error: { file, message: `文件大小超过${maxSize}M` },
					message: `${file.name}文件大小超过${maxSize}M`,
				})
			}
		}

		let uploadAxios: any
		switch (apiName) {
			case 'uploadFile':
				uploadAxios = VisitorApi.uploadFile
				break
			case 'uploadImage':
				uploadAxios = VisitorApi.uploadImage
				break
			case 'operateAndUpload':
				uploadAxios = VisitorApi.operateAndUpload
				break
			default:
				break
		}
		if (!uploadAxios) {
			console.error(`uploadFiles无匹配的上传文件方法`)
			return reject()
		}

		let count = 0,
			suc = 0,
			total = fileList.length
		let uploadedList: any[] = [],
			failedList: any[] = []

		// TODO 用promise替换当前实现
		for (const file of fileList) {
			const formData = new FormData()
			formData.append('filecontent', file)

			uploadAxios({ formData })
				.then((res: any) => {
					suc++
					uploadedList.push({ file, data: res.data })
				})
				.catch((err: any) => {
					failedList.push({ file, err: err.message || '上传失败' })
				})
				.finally(() => {
					if (++count === total) {
						if (suc === total) {
							resolve({
								message: '上传成功',
								uploaded: uploadedList,
							})
						} else {
							reject({
								error: failedList,
								message: '上传失败',
								uploaded: uploadedList,
							})
						}
					}
				})
		}
	})
}
